import "./Tags.css";
import lod_ from "lodash";
import React from "react";
import { Tooltip } from "@material-ui/core";
import { Chip } from "@mui/material";
import DoneIcon from "@material-ui/icons/Done";
import { getLabel } from "helpers/utilities";

/**
 *
 * @param {*} param0
 * @returns
 */
export const TagsList = ({
	list,
	labelField,
	surnameField,
	titleField,
	isForm,
	scroll,
	align = "center",
	selected,
	setSelected,
	isIntent,
	isUser,
	multiple = true
}) => {
	/**
	 *
	 * @param {*} value
	 * @returns
	 */
	const toggleSelect = value => () => {
		if (selected && multiple === true) {
			const currentIndex = selected.indexOf(value);
			const newSelected = [...selected];

			if (currentIndex === -1) {
				newSelected.push(value);
			} else {
				newSelected.splice(currentIndex, 1);
			}

			setSelected(newSelected);
		}
		if (selected && multiple === false) {
			const newSelected = [value];

			setSelected(newSelected);
		}
	};
	let tagListScrollStyle = {
		display: "flex",
		justifyContent: "left",
		listStyle: "none",
		margin: 0
	};
	if (scroll) {
		tagListScrollStyle.flexWrap = "nowrap";
		tagListScrollStyle.overflow = "auto";
	} else {
		tagListScrollStyle.flexWrap = "wrap";
		tagListScrollStyle.justifyContent = align;
		tagListScrollStyle.width = "100%";
	}

	return (
		<span
			className={isForm ? "tagListForm" : "tagListScroll"}
			style={
				!isForm
					? tagListScrollStyle
					: {
							display: "flex",
							flexWrap: "wrap",
							width: "100%"
						}
			}
		>
			{list?.map(tag => {
				let label = lod_.get(tag, labelField, "");
				let title = lod_.get(tag, titleField, "");

				if (isUser) {
					label = tag[labelField] + " " + tag[surnameField];
				}
				/**
				 * PIKA 2025.06.14 - tag of type intent do not have name, hence
				 */
				let textToDisplay = label;
				if (textToDisplay === undefined || textToDisplay === null || textToDisplay === "") {
					textToDisplay = tag?.label?.fr; // here we must support either French or English depending on client browser config
					if (textToDisplay === undefined || textToDisplay === null || textToDisplay === "") {
						textToDisplay = tag.code;
						if (textToDisplay === undefined || textToDisplay === null || textToDisplay === "") {
							textToDisplay = "-No Code-";
						}
					}
				}
				label = textToDisplay;

				return (
					<Tooltip title={title} key={label}>
						<Chip
							style={{ textTransform: isUser ? "capitalize" : "initial" }}
							label={isIntent ? getLabel(label) : label}
							icon={isForm ? selected.includes(tag) ? <DoneIcon /> : <></> : <></>}
							color={isForm ? (selected.includes(tag) ? "primary" : "default") : "default"}
							clickable={isForm ? true : false}
							onClick={toggleSelect(tag)}
						/>
					</Tooltip>
				);
			})}
		</span>
	);
};
